// @flow
import { combineReducers, type Reducer } from 'redux';

import { reducer as machine } from './Machine';
import { reducer as pendingStatus } from './PendingStatus';
import { reducer as user } from './User';
import { reducer as pit } from './Pit';
import { reducer as card } from './Card';

export default function createReducer(asyncReducers: { [string]: Reducer<*, *> }) {
  return combineReducers({
    ...asyncReducers,
    machine,
    pendingStatus,
    user,
    pit,
    card,
  });
}
